

export default {
    id:"useSwipeGesture",
    type:"(options:object):void",
    options:[
        {name:"element",type:"HTMLElement"},
        {
            name:"length",
            type:"number",
            description:`
                Minimum swipe length in pixels from start position to the end position that triggers listeners
                @default 40
            `,
        },
        {
            name:"offset",
            type:"number",
            description:`
                Tolerated gesture offset in pixels
                @default 50
            `,
        },
        {
            name:"pointerCount",
            type:"number",
            description:`
                The exact number of pointers that triggers the Swipe Gesture.
                @default 1
            `,
        },
        {
            name:"onReady",
            type:"(event:TouchEvent):void",
            description:"Called When the exact number of pointers is detected and the listeners are ready",
        },
        {
            name:"onSwipe",
            type:"(event:SwipeEvent):void",
            description:"Called when a swipe gesture is captured",
            props:[
                {
                    name:"SwipeEvent",
                    type:"TouchEvent",
                    props:[
                        {
                            name:"axis",
                            type:`"horizontal"|"vertical"`,
                        },
                        {
                            name:"direction",
                            type:`"top"|"left"|"bottom"|"right"`,
                        },
                        ...["dx","dy"].map(name=>({name,type:"number"})),
                    ],
                }
            ],
        },
    ],
}
